import React from "react";

export const QuizProgress = ({ step, totalSteps, complete }) => {
  const progress = complete ? 100 : Math.round((step / totalSteps) * 100);
  return (
    <div className="flex items-center gap-4 mb-12">
      <div className="flex-1 h-px bg-[#1a1814]/15 relative overflow-hidden">
        <div
          className="absolute inset-y-0 left-0 bg-[#1a1814] transition-all duration-700"
          style={{ width: `${progress}%` }}
        />
      </div>
      <span className="micro-label text-[#1a1814]/60" data-testid="quiz-progress">
        {complete ? "Complete" : `${String(step + 1).padStart(2, "0")} / ${String(totalSteps).padStart(2, "0")}`}
      </span>
    </div>
  );
};
